module.exports = {"533325101":"金顶镇","533325102":"啦井镇","533325103":"营盘镇","533325104":"通甸镇","533325201":"河西乡","533325202":"中排乡","533325203":"石登乡","533325204":"兔峨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/533325.json
// module id = 2805
// module chunks = 0